<template>
  <section>
    <div @click="closeInterests" id="backgroundClick"></div>
    <div class="selectBox isWindow">
      <div id="editProfileTitleRow">
        <div>
          <p class="boldEditTitle">Edit Interests</p>
          <div id="saveNote">
            Selected {{ interestCount }}/{{ maxInterests }} Interests
          </div>
        </div>
        <button class="closeEdit" @click="closeInterests"></button>
      </div>
      <div id="editInterests">
        <p class="interestTitle">Sports</p>
        <div
          class="interestContainer"
          v-for="(interest, index) in sports"
          :key="'A' + index"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Outdoors</p>
        <div
          class="interestContainer"
          v-for="(interest, index1) in outdoor"
          :key="'B' + index1"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Social</p>
        <div
          class="interestContainer"
          v-for="(interest, index2) in social"
          :key="'C' + index2"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Creative</p>
        <div
          class="interestContainer"
          v-for="(interest, index3) in creative"
          :key="'D' + index3"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Food &amp; Drink</p>
        <div
          class="interestContainer"
          v-for="(interest, index4) in food"
          :key="'E' + index4"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Entertainment</p>
        <div
          class="interestContainer"
          v-for="(interest, index5) in entertainment"
          :key="'F' + index5"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Wellness</p>
        <div
          class="interestContainer"
          v-for="(interest, index6) in wellness"
          :key="'G' + index6"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">Tech</p>
        <div
          class="interestContainer"
          v-for="(interest, index7) in tech"
          :key="'H' + index7"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
        <p class="interestTitle">World Affairs</p>
        <div
          class="interestContainer"
          v-for="(interest, index8) in world"
          :key="'I' + index8"
          @click="select(interest)"
        >
          <Interest
            :icon="interest[0]"
            :interest="interest[1]"
            :added="interest[2]"
          />
        </div>
      </div>
      <div id="saveInterests">
        <button class="saveButton" @click="saveInterests">Save</button>
      </div>
    </div>
  </section>
</template>

<script>
import Interest from "@/components/profile/Interest";
import { mapState } from "vuex";
import db from "@/db";
import firebase from "@/firebase";

export default {
  props: ["selectedInterests", "isProfile", "maxInterests"],

  components: {
    Interest,
  },

  data: () => ({
    sports: [
      [0x26be, "Baseball", false],
      [0x1f3c0, "Basketball", false],
      [0x1f3c6, "Fantasy sports", false],
      [0x1f3c8, "Football", false],
      [0x1f94f, "Frisbee", false],
      [0x26f3, "Golf", false],
      [0x1f3d2, "Hockey", false],
      [0x1f94d, "Lacrosse", false],
      [0x1f3f8, "Racquet sports", false],
      [0x1f9d7, "Rock climbing", false],
      [0x1f3c9, "Rugby", false],
      [0x1f45f, "Running", false],
      [0x26f5, "Sailing", false],
      [0x1f3bf, "Skiing", false],
      [0x26bd, "Soccer", false],
      [0x1f3ca, "Swimming", false],
      [0x1f3cb, "Working out", false],
    ],
    outdoor: [
      [0x1f3d5, "Camping", false],
      [0x1f3a3, "Fishing", false],
      [0x1f97e, "Hiking", false],
      [0x1f3f9, "Hunting", false],
      [0x1f6b5, "Mountain Biking", false],
    ],
    social: [
      [0x1f37b, "Beer tasting", false],
      [0x1f92a, "Partying", false],
      [0x1f3a4, "Karaoke", false],
      [0x1f9e5, "Thrifting", false],
      [0x1f440, "Meet people", false],
    ],
    creative: [
      [0x1f3ad, "Cosplaying", false],
      [0x1f483, "Dance", false],
      [0x270f, "Drawing", false],
      [0x1f58c, "Painting", false],
      [0x1f9e3, "Fashion", false],
      [0x1f3b5, "Music", false],
      [0x1f4f7, "Photography", false],
      [0x1f58b, "Writing", false],
    ],
    food: [
      [0x1f957, "Nutrition", false],
      [0x1f967, "Cooking", false],
      [0x2615, "Coffee", false],
      [0x1f37d, "Fine Dining", false],
      [0x1f35e, "Baking", false],
    ],
    entertainment: [
      [0x1f4fa, "Binge-watching", false],
      [0x1f0cf, "Board/card games", false],
      [0x265f, "Chess", false],
      [0x1f47e, "Gaming", false],
      [0x1f4d6, "Reading", false],
      [0x1f39e, "Movies", false],
    ],
    wellness: [
      [0x1f9f6, "Knitting", false],
      [0x1f9d8, "Meditation", false],
      [0x1f60c, "Yoga", false],
      [0x2708, "Travel", false],
      [0x1f463, "Volunteering", false],
      [0x1fab4, "Gardening", false],
    ],
    tech: [
      [0x1f4bb, "Programming", false],
      [0x1f171, "Crypto", false],
      [0x1f399, "Podcasts", false],
      [0x1f97d, "VR gaming", false],
      [0x1f5a5, "Tech products", false],
    ],
    world: [
      [0x1f454, "Politics", false],
      [0x1f4c8, "Stocks", false],
      [0x2696, "Social issues", false],
      [0x1f30e, "Climate", false],
      [0x1f4dc, "History", false],
    ],
    selected: false,
    interests: [],
    interestCount: 0,
    added: false,
  }),
  created() {
    if (this.selectedInterests) {
      for (var i = 0; i < this.selectedInterests.length; i++) {
        let object = this.selectedInterests[i];
        let interest = [];
        interest.push(object.unicode);
        interest.push(object.name);
        interest.push(true);
        this.interests.push(interest);
        this.checkIndex(
          this.sports.findIndex((x) => x[1] === interest[1]),
          this.sports
        );
        this.checkIndex(
          this.outdoor.findIndex((x) => x[1] === interest[1]),
          this.outdoor
        );
        this.checkIndex(
          this.social.findIndex((x) => x[1] === interest[1]),
          this.social
        );
        this.checkIndex(
          this.creative.findIndex((x) => x[1] === interest[1]),
          this.creative
        );
        this.checkIndex(
          this.food.findIndex((x) => x[1] === interest[1]),
          this.food
        );
        this.checkIndex(
          this.entertainment.findIndex((x) => x[1] === interest[1]),
          this.entertainment
        );
        this.checkIndex(
          this.wellness.findIndex((x) => x[1] === interest[1]),
          this.wellness
        );
        this.checkIndex(
          this.tech.findIndex((x) => x[1] === interest[1]),
          this.tech
        );
        this.checkIndex(
          this.world.findIndex((x) => x[1] === interest[1]),
          this.world
        );
        this.checkIndex(
          this.sports.findIndex((x) => x[1] === interest[1]),
          this.sports
        );
      }
    } else {
      this.selectedInterests = [];
    }
    this.interestCount = this.interests.length;
  },
  mounted() {
    this.$store.commit("profile/setCanAddInterests", true);
  },

  computed: {
    ...mapState("profile", [
      "canAddInterests",
      "isEditingInterest",
      "newInterests",
    ]),
  },

  methods: {
    checkIndex(index, array) {
      if (index != -1) {
        array[index][2] = true;
      }
    },
    select(interest) {
      const index = this.interests.findIndex((x) => x[1] === interest[1]);
      if (index != -1) {
        this.interests.splice(index, 1);
        interest[2] = false;
      } else {
        if (this.interests.length < this.maxInterests) {
          this.interests.push(interest);
          interest[2] = true;
        }
      }

      if (this.interests.length < this.maxInterests) {
        this.$store.commit("profile/setCanAddInterests", true);
      } else {
        this.$store.commit("profile/setCanAddInterests", false);
      }
      this.interestCount = this.interests.length;
    },

    async saveInterests() {
      var interests = [];
      for (var i = 0; i < this.interests.length; i++) {
        let object = {
          unicode: this.interests[i][0],
          name: this.interests[i][1],
        };
        interests.push(object);
      }
      if (this.isProfile) {
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            interests: interests,
          });
      } else {
        this.$store.commit("profile/setInterests", interests);
      }
      this.$store.commit("profile/setIsEditingInterest", false);
    },
    async closeInterests() {
      this.$store.commit("profile/setIsEditingInterest", false);
    },
  },
};
</script>

<style scoped>
#backgroundClick {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
}
#editInterest {
  z-index: 4;
}
.selectBox {
  background-color: white;
  width: 700px;
  height: 600px;
  z-index: 4 !important;
  border-radius: 10px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}
#editProfileTitleRow {
  top: 0;
  width: 100%;
  height: 100px;
  border-bottom: lightgrey solid thin;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 3;
  position: relative;
}
#editInterests {
  height: fit-content;
  overflow-y: auto !important;
  z-index: 3;
}
.boldEditTitle {
  font-size: 20px;
  color: black;
  font-weight: bold;
}
.interestTitle {
  font-size: 20px;
  color: black;
  font-weight: 550;
  margin: 5px;
}
.interestContainer {
  display: inline-block;
  margin: 2px 2px 5px 10px;
}
.interestCountHover {
  border: 1px solid #f0f0f0;
  box-shadow: 1px 1px 6px #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-size: 20px;
  width: 100%;
  z-index: 5;
}
#saveInterests {
  width: 100%;
  padding: 10px;
  min-height: 60px;
  border-top: lightgrey solid thin;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3;
}
#saveNote {
  height: 10px;
  width: 100%;
  font-size: 13px;
}
.saveButton {
  width: 100%;
  height: 100%;
  min-height: 39px;
  color: rgb(9, 132, 227);
  font-weight: 600;
  font-size: 18px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  background-color: #0fb9b150;
}
.saveButton:hover {
  background-color: #0fb9b190;
}
.saveButton:active {
  transform: scale(0.97);
}
.closeEdit {
  position: absolute;
  right: 10px;
  height: 40px;
  width: 40px;
  border: none;
  border-radius: 50%;
  background-image: url("../../assets/closeEdit.svg");
  background-color: #e0e0e0;
  cursor: pointer;
  z-index: 3;
}
.closeEdit:hover {
  background-color: #cacaca;
}
.closeEdit:active {
  transform: scale(0.9);
}
</style>
